export default "__VITE_ASSET__DKGolQuA__"